import { render, staticRenderFns } from "./UserAuthorizeModal.vue?vue&type=template&id=4c6cc740&scoped=true"
import script from "./UserAuthorizeModal.vue?vue&type=script&lang=js"
export * from "./UserAuthorizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6cc740",
  null
  
)

export default component.exports